import type { ReactNode } from 'react';

export const symbol_blinds_closed: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M160-180v-600q0-24.75 17.63-42.38Q195.25-840 220-840h520q24.75 0 42.38 17.62Q800-804.75 800-780v600h50q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H665q0 25-17.6 42.5T604.9-60q-24.9 0-42.4-17.57T545-120H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-180 110-180h50Zm60-495h355v-105H220v105Zm415 0h105v-105H635v105ZM220-510h355v-105H220v105Zm415 0h105v-105H635v105ZM220-345h355v-105H220v105Zm415 0h105v-105H635v105ZM220-180h355v-105H220v105Zm415 0h105v-105H635v105Z"
		/>
	</svg>
);
